import { Helmet } from "react-helmet";
import TestimonialSliderTwo from "../components/common/sliders/testimonial/testimonial-slider-two";
import TextSliderOne from "../components/common/sliders/text/text-slider-one";
import VideoSectionThree from "../components/common/video/video-section-three";
import FeatureSection from "../components/home-two/feature-section";
import FeatureSectionTwo from "../components/home-two/feature-section-two";
import HeroThumbSection from "../components/home-two/hero-thumb-section";
import HomeTwoHeroSection from "../components/home-two/home-two-hero-section";
import TradingSection from "../components/home-two/trading-section";
import TradingSectionTwo from "../components/home-two/trading-section-two";

export default function HomeTwo() {
	return (
		<>
			<Helmet>
				<title>fugu - index -02</title>
			</Helmet>
			<HomeTwoHeroSection />
			<HeroThumbSection />
			<FeatureSection />
			<TextSliderOne />
			<VideoSectionThree />
			<TradingSection />
			<FeatureSectionTwo />
			<TradingSectionTwo />
			<TestimonialSliderTwo />
		</>
	);
}

